import { getProductFinalPrice, getProductFinalPriceWithTax, truncateNumber } from '$lib/js/helpers'
import { PUBLIC_PROD } from '$env/static/public'


/**
 * Event for "Add to cart"
 */
export function registerAddToCartEvent(product: {
	sku: string,
	name: string,
	cart_qty?: number,
	price_with_tax: number,
}) {
	const price = truncateNumber(getProductFinalPriceWithTax(product), 2)

	let body = {
		currency: 'EUR',
		value: price,
		items: [{
			item_id: product.sku,
			item_name: product.name,
			price: price,
			quantity: product.cart_qty || 1,
		}],
	}

	try {
		gtag('event', 'add_to_cart', body)
		fbq('track', 'AddToCart', {
			'content_ids': [product.sku],
			'content_type': 'product',
			'currency': 'EUR',
			'value': price,
		})
	} catch (error) {

	}


	// window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
	// window.dataLayer.push({
	//   event: "add_to_cart",
	//   ecommerce: body
	// });
}

export function registerViewItemEvent(product: {
	sku: string,
	name: string,
	price_with_tax: number,
}, brand: {page_title: string} | undefined) {
	const price = truncateNumber(getProductFinalPriceWithTax(product), 2)
	let body = {
		'value': price,
		'currency': 'EUR',
		'items': [
			{
				'item_id': product.sku,
				'item_name': product.name,
				'item_brand': brand?.page_title || undefined,
				'price': price,
				'google_business_vertical': 'retail',
			}],
	}

	try {
		gtag('event', 'view_item', body)
		fbq('track', 'ViewContent', {
			'content_ids': [product.sku],
			'content_type': 'product',
			'currency': 'EUR',
			'value': price,
		})
	} catch (error) {
	}

	//   window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
	//   window.dataLayer.push({
	//     event: "view_item",
	//     ecommerce: body
	//   });
}


/**
 * Event for "View category".
 */
export function registerViewItemListEvent(category: { id: any, name: any }, products: {
	sku: string,
	name: string,
	price: number,
}[]) {
	let body = {
		item_list_id: category.id,
		item_list_name: category.name,
		items: [] as Record<string, unknown>[],
	}

	let i = 0
	let ids: string[] = []
	for (let product of products) {
		i += 1
		ids.push(product.sku)
		body.items.push({
			item_id: product.sku,
			item_name: product.name,
			affiliation: 'Google Merchandise Store',
			// TODO: @JB, is this code still necessary?
			coupon: 'SUMMER_FUN',
			discount: 2.22,
			index: i,
			price: getProductFinalPrice(product), // should this be with tax?
		})
	}


	try {
		gtag('event', 'view_item_list', body)
		fbq('track', 'ViewContent', {
			'content_ids': ids,
			'content_type': 'product',
		})

	} catch (error) {

	}
	//   window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
	//   window.dataLayer.push({
	//     event: "view_item",
	//     ecommerce: body
	//   });
}

/**
 * Event for "View search".
 */
export function registerSearchEvent(search_term: string) {
	if (PUBLIC_PROD === '1') {
		try {
			gtag('event', 'search', {
				search_term: search_term,
			})
		} catch (error) {

		}
	}
}


/**
 * Register any click in any button
 */
export function registerClickEvent(label: string, category: string = 'global') {
	if (PUBLIC_PROD === '1') {
		try {
			gtag('event', 'button_click', {
				event_category: category,
				event_label: label
			});
		} catch (error) {

		}
	}
}
